export enum LocationTypeEnum {
    ALARM = 'Alarm',
    AGENT = 'Agent',
    ALI = 'ALI',
    DBH = 'DBH',
    PHONE = 'Phone',
    TELEMATICS = 'Telematics',
    TEXT = 'Text',
    VOIP = 'VoIP',
    WPH1 = 'WPH1',
    WPH2 = 'WPH2'
}
